module.exports = __webpack_public_path__ + "img/youtube.66dfd5fb.jpg";